import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home-item-icon",
  "use": "icon-home-item-icon-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 40 40\" id=\"icon-home-item-icon\">\n<style type=\"text/css\">\n\t#icon-home-item-icon .st0{fill:#1B86CE;}\n</style>\n<path id=\"icon-home-item-icon_人才招聘\" class=\"st0\" d=\"M20,21.5c2.4,0,4.7,0.3,7,1c2.2,0.6,3.7,2.6,3.7,4.9v1.2c0,1.3-1.1,2.4-2.4,2.4h0H11.7\n\tc-1.3,0-2.4-1.1-2.4-2.4v-1.2c0-2.3,1.5-4.3,3.7-4.9C15.3,21.8,17.6,21.5,20,21.5z M20,22.7c-0.6,0-0.9,0.2-0.9,0.6l-0.8,4.4\n\tc0,0.2,0,0.4,0.2,0.5l1.1,1.2c0.2,0.2,0.6,0.2,0.8,0c0,0,0,0,0,0l1.1-1.2c0.1-0.1,0.2-0.3,0.2-0.5l-0.9-4.4\n\tC20.9,22.9,20.6,22.7,20,22.7L20,22.7z M20,9c3.3,0,5.9,2.7,5.9,5.9c0,3.3-2.7,5.9-5.9,5.9s-5.9-2.7-5.9-5.9l0,0\n\tC14.1,11.7,16.7,9,20,9L20,9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home-item-icon.svg
// module id = 1Vgu
// module chunks = 97